import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Input, Button, FormGroup, Label } from "reactstrap";

import staffService from "../../services/staffService";
import alertActions from "../../actions/alertActions";

const ApproveAttorneys = () => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState({
    att: { attorneyRegistrationId: 0 },
  });
  const [getAttys, setGetAttys] = useState(true);
  const [hideApprove, setHideApprove] = useState(false);
  const size = users.length + 1;

  // useEffect(() => {
  //   staffService.getAttorneyRegistrations().then((payload) => {
  //     setUsers(payload);
  //     if (payload.length === 0) {
  //       setSelected({ ...selected, att: { attorneyRegistrationId: "0" } });
  //     } else {
  //       setSelected({ ...selected, att: payload[0] });
  //     }
  //   });
  // }, []); //If we pass an empty array to useEffect, it’s only executed after the first render.

  useEffect(() => {
    if (getAttys) {
      staffService.getAttorneyRegistrations().then((payload) => {
        setUsers(payload);
        if (payload.length === 0) {
          setSelected({ ...selected, att: { attorneyRegistrationId: "0" } });
        } else {
          console.log(payload[0]);
          setSelected({ ...selected, att: payload[0] });
          checkEmail(payload[0].email);
        }
        setGetAttys(false);
      });
    }
  }, [getAttys, selected]);

  const onSelect = (evt) => {
    const { value } = evt.target;
    let foundAtt = users.find((user) => user.attorneyRegistrationId == value);
    //console.log(foundAtt);
    setSelected({ ...selected, att: foundAtt });
    checkEmail(foundAtt.email);
  };

  const deny = (evt) => {
    const { value } = evt.target;
    staffService.denyAttorney(value).then(() => {
      setGetAttys(true);
      dispatch(alertActions.success("Successfully denied attorney."));
    });
  };

  const approve = (evt) => {
    const { value } = evt.target;
    staffService.approveAttorney(value).then(() => {
      setGetAttys(true);
      dispatch(alertActions.success("Successfully approved attorney."));
    });
  };

  const checkEmail = (email) => {
    staffService.checkEmail(email).then((payload) => {
      if (payload.boolVal) {
        setHideApprove(true);
      } else {
        setHideApprove(false);
      }
    });
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h2>Approve/Deny attorney registration</h2>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <FormGroup row>
            {users.length > 0 && (
              <Label sm={12}>Select an attorney for approval</Label>
            )}
            <Col sm={12}>
              {users.length > 0 && (
                <Input
                  type="select"
                  name="select"
                  size={size.toString()}
                  onChange={(e) => onSelect(e)}
                >
                  {users.map((u) => (
                    <option
                      value={u.attorneyRegistrationId}
                      key={u.attorneyRegistrationId}
                    >
                      {u.lastName}, {u.firstName}
                    </option>
                  ))}
                </Input>
              )}
            </Col>
          </FormGroup>
        </Col>
        {users.length === 0 && (
          <Col md={9}>
            <Label sm={12}>There are no attorneys pending approval</Label>
          </Col>
        )}

        {users.length > 0 && selected.att.attorneyRegistrationId !== "0" && (
          <Col md={9}>
            <Row>
              <Col>
                <h4 className="text-center">
                  {selected.att.lastName}, {selected.att.firstName}
                </h4>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <b>Phone number</b>
              </Col>
              <Col>{selected.att.phoneNumber}</Col>
            </Row>
            <Row>
              <Col md={2}>
                <b>Email</b>
              </Col>
              <Col>
                {selected.att.email}
                <b className="text-danger">
                  {hideApprove
                    ? "  - This email is already taken and cannot be reused!"
                    : ""}
                </b>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <b>Bar number</b>
              </Col>
              <Col>{selected.att.barNumber}</Col>
            </Row>
            <Row>
              <Col>
                <Button
                  type="button"
                  value={selected.att.attorneyRegistrationId}
                  onClick={(evt) => approve(evt)}
                  color={hideApprove ? "secondary" : "primary"}
                  disabled={hideApprove}
                >
                  Approve
                </Button>{" "}
                <Button
                  type="button"
                  value={selected.att.attorneyRegistrationId}
                  onClick={(evt) => deny(evt)}
                  color="danger"
                >
                  Deny
                </Button>
                {hideApprove}
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};

export default ApproveAttorneys;
